import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminRetrieveAdmins = createAsyncThunk<AdminVM[], void, { extra: Partial<Dependencies> }>(
  "admins/adminRetrieveAdmins",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.adminList();
  },
);
